export const SERVICES = [
  { key: "all", name: "All", path: "/" },
  { key: "paid-traffic", name: "Paid Traffic", path: "/paid-traffic" },
  { key: "ad-creative", name: "Ad Creative", path: "/ad-creative" },
  { key: "retention", name: "Retention", path: "/retention" },
  { key: "aeo", name: "AEO", path: "/aeo" },
];

export const SERVICE_INTROS = {
  "paid-traffic": {
    titleBefore: "Paid traffic that ",
    titleBold: "pays for itself",
    titleAfter: ".",
    intro:
      "Meta is the core. We also run Google, TikTok and AppLovin. We manage to contribution margin, not ROAS, and we build the creative in-house.",
  },
  "ad-creative": {
    titleBefore: "Creative built to ",
    titleBold: "be scaled",
    titleAfter: ".",
    intro:
      "Statics and video, both from your existing content and from UGC creators we source and direct. Volume, iteration and a scoreboard for every concept.",
  },
  retention: {
    titleBefore: "Email and SMS that looks as good as ",
    titleBold: "it performs",
    titleAfter: ".",
    intro:
      "Klaviyo flows and campaigns with design that matches the brand. We report revenue per recipient and profit, not open rates.",
  },
  aeo: {
    titleBefore: "Be ",
    titleBold: "the answer",
    titleAfter: ".",
    intro:
      "Answer engine optimization: getting your brand recommended inside ChatGPT, Perplexity and Google AI Overviews for the questions your customers ask.",
  },
};

export const isPlaceholder = (s) =>
  typeof s === "string" && s.trim().startsWith("[PLACEHOLDER");
